import { render, staticRenderFns } from "./Level4CategoryMenuItem.vue?vue&type=template&id=5e8face8&scoped=true&"
import script from "./Level4CategoryMenuItem.vue?vue&type=script&lang=js&"
export * from "./Level4CategoryMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./Level4CategoryMenuItem.vue?vue&type=style&index=0&id=5e8face8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8face8",
  null
  
)

export default component.exports